/**
 * Debug overlay: FPS, GPU stats, streaming + NPC metrics.
 */
export class PerformanceHUD {
  constructor() {
    /** @type {HTMLElement | null} */
    this._el = null;
    this._visible = true;
  }

  mount(parent) {
    if (this._el) return;
    const el = document.createElement('div');
    el.className = 'perf-hud';
    el.hidden = !this._visible;
    parent.appendChild(el);
    this._el = el;
    this._injectStyles();
  }

  /**
   * @param {{
   *   fps: number;
   *   frameMs: number;
   *   drawCalls: number;
   *   triangles: number;
   *   npcCount: number;
   *   npcFull: number;
   *   npcMedium: number;
   *   npcFar: number;
   *   npcStatic: number;
   *   activeChunks: number;
   *   buildingsLoaded: number;
   *   buildingsVisible: number;
   *   geometries: number;
   *   textures: number;
   * }} stats
   */
  update(stats) {
    if (!this._el) return;
    this._el.innerHTML = `
      <div class="perf-hud-title">PERF</div>
      <div>FPS ${stats.fps} · ${stats.frameMs.toFixed(1)} ms</div>
      <div>Draw ${stats.drawCalls} · Tri ${formatK(stats.triangles)}</div>
      <div>Geo ${stats.geometries} · Tex ${stats.textures}</div>
      <div>NPC ${stats.npcCount} (F${stats.npcFull}/M${stats.npcMedium}/D${stats.npcFar}/S${stats.npcStatic})</div>
      <div>Chunks ${stats.activeChunks} · Bld ${stats.buildingsVisible}/${stats.buildingsLoaded}</div>
    `;
  }

  setVisible(visible) {
    this._visible = visible;
    if (this._el) this._el.hidden = !visible;
  }

  dispose() {
    this._el?.remove();
    this._el = null;
  }

  _injectStyles() {
    if (document.getElementById('perf-hud-styles')) return;
    const style = document.createElement('style');
    style.id = 'perf-hud-styles';
    style.textContent = `
      .perf-hud {
        position: absolute;
        bottom: 1rem;
        right: 1rem;
        padding: 0.55rem 0.7rem;
        font-family: Consolas, monospace;
        font-size: 0.72rem;
        line-height: 1.35;
        color: #ff2040;
        background: rgba(0, 0, 0, 0.62);
        border: 1px solid rgba(255, 32, 64, 0.35);
        pointer-events: none;
        letter-spacing: 0.04em;
      }
      .perf-hud-title {
        font-weight: 700;
        margin-bottom: 0.25rem;
        letter-spacing: 0.1em;
      }
    `;
    document.head.appendChild(style);
  }
}

function formatK(n) {
  if (n >= 1000000) return `${(n / 1000000).toFixed(1)}M`;
  if (n >= 1000) return `${(n / 1000).toFixed(1)}k`;
  return String(n);
}
